import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class BookingTimerService {
  private timeLeft: number = 0;
  private interval: any;

  constructor(private router: Router, private route: ActivatedRoute) { }

  setTime(minutes: number) {
    this.timeLeft = minutes * 60;
    localStorage.setItem('bookingTimeLeft', this.timeLeft.toString());
    const expiryTime = new Date().getTime() + this.timeLeft * 1000;
    localStorage.setItem('bookingExpiryTime', expiryTime.toString());
  }


  startTimer() {
    this.loadTimer();

    this.interval = setInterval(() => {
      const now = new Date().getTime();
      const expiryTime = parseInt(localStorage.getItem('bookingExpiryTime') || '0', 10);
      this.timeLeft = Math.max(0, Math.floor((expiryTime - now) / 1000));
      localStorage.setItem('bookingTimeLeft', this.timeLeft.toString());

      if (this.timeLeft <= 0) {
        clearInterval(this.interval);
        localStorage.removeItem('bookingTimeLeft');
        localStorage.removeItem('bookingExpiryTime');
        //this.route.url.subscribe(urlSegments => {
        //  if (urlSegments.some(segment => segment.path === 'passengerInfo')) {
            this.router.navigate(['/flightSearch']);
        //  }
        //});
      }
    }, 1000);
  }

  stopTimer() {
    clearInterval(this.interval);
    localStorage.removeItem('bookingTimeLeft');
    localStorage.removeItem('bookingExpiryTime');
  }

  getTimeLeft() {
    return this.timeLeft;
  }

  private loadTimer() {
    const storedTime = localStorage.getItem('bookingTimeLeft');
    if (storedTime) {
      this.timeLeft = parseInt(storedTime, 10);
    }
  }
}
